import { render, staticRenderFns } from "./PropagateAdd.vue?vue&type=template&id=90f8cce2&scoped=true"
import script from "./PropagateAdd.vue?vue&type=script&lang=js"
export * from "./PropagateAdd.vue?vue&type=script&lang=js"
import style0 from "./PropagateAdd.vue?vue&type=style&index=0&id=90f8cce2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90f8cce2",
  null
  
)

export default component.exports